
export const attachWidgetRefereshEvents = () => {
    document.addEventListener('content:update', function(){

        if(window.Yotpo && window.yotpo){
            // v2 widgets
            var yotpoApi = new window.Yotpo.API(window.yotpo);
            yotpoApi.refreshWidgets();
        }

        if (window.yotpoWidgetsContainer) {
            //v3 widgets
            window.yotpoWidgetsContainer.initWidgets && window.yotpoWidgetsContainer.initWidgets();
        }

    });
}